import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_DimensionRow,
    WB_ReportTileDimensionRow,
    WB_ReportTileRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbReportTile} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Dimension,
    esWB_ReportTile,
    esWB_ReportTile_Dimension
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";

export class ReportTileBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Report: WB_ReportTileRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Report'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Report = null;
    }

    get WB_Report(): WB_ReportTileRow
    {
        return this.drWB_Report;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating Report");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Report.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_ReportTile)
                .then((newReportRow: WB_ReportTileRow)=> {
                    newReportRow.setDefaults()
                    self.drWB_Report = newReportRow;
                    self.dbContext.add(esWB_ReportTile, newReportRow)
                    self.Identity.setAll(self.WB_Report.cif.WB_REPORTTILE_ID, self.WB_Report.cif.REPORT_ID, self.WB_Report.cif.REPORT_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Report, 'WB_REPORTTILE_ID','REPORT_ID','REPORT_NAME')
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    resolve(self);

                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err)
                    error(err)
                })

        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {
        var self = this;
        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading Report (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "Report already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                let sError = "Unable to determine dbContext for new Report.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            let recordResolver = new ESRecordResolver(this.dbContext, {
                standardConditions: {
                    [esWB_ReportTile]: {"DELETED_IND": {"notIn": ['1']}},
                    [esWB_ReportTile_Dimension]: {"DELETED_IND": {"notIn": ['1']}}
                },
                dctIncludeBelongsToNamedRelations: {
                    [esWB_ReportTile_Dimension]: [esWB_Dimension]
                }
            })

            // Read in Startup Applications First..they may not be related to a Application Suite
            recordResolver.queryAllWithRelationships(esWB_ReportTile, {WB_REPORTTILE_ID:anId})
                .then(function (aReportsRow:WB_ReportTileRow[]){

                    if(_.isEmpty(aReportsRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_Report = aReportsRow[0];
                    self.Identity.setAll(self.WB_Report.cif.WB_REPORTTILE_ID, self.WB_Report.cif.REPORT_ID, self.WB_Report.cif.REPORT_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Report, 'WB_REPORTTILE_ID','REPORT_ID','REPORT_NAME')

                    return (self.drWB_Report.loadRelations([esWB_ReportTile_Dimension, esWB_Dimension],
                        self.LoadOptions));
                })
                .then((aReportsRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Report.cif.REPORT_NAME + "(" + self.WB_Report.cif.REPORT_ID + ")");
        return new Promise<IBusinessObject>( (resolve, reject) => {
            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate Reports.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            if (self.WB_Report.cif.REPORT_TYPE_ID == "PAReport") {
                let oRenderOptions: any = undefined;
                try {
                    oRenderOptions = JSON.parse(self.WB_Report.cif.RENDER_OPTIONS || "");
                } catch (err) {
                    oRenderOptions = undefined;
                }

                let sIDocId = _.isPlainObject(oRenderOptions) ? oRenderOptions.iDocid : undefined;

                if (!(_.isString(sIDocId) && !_.isEmpty(sIDocId.trim()))) {
                    self.ValidateMessageProvider.addMessage({
                        code: 'invalidPAReportRenderOptions',
                        type: MessageType.Error,
                        title: "Render Options for a PA Report must contain 'iDocid' set to a non-blank '<FunctionArea>/<ReportName>' path (relative to PA.Controls.Visualization).",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
                }
            }

            self._bIsValidated = (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0);
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbReports = <IwbReportTile>self.drWB_Report;
        this.SaveProgressProvider.start("Saving " + wbReports.REPORT_NAME + "(" + wbReports.REPORT_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Reports.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            var bDone = false;

            self.Validate({})
                .then((ignore) => {
                    if (!self.bIsValidated) {
                        self._bIsSaved = false;
                        bDone = true;
                        self.SaveProgressProvider.finish();
                        resolve(self);
                        return
                    }
                })
                .then((ignore) => {
                    if (bDone) return
                    return saveFunction(esWB_ReportTile, self.drWB_Report,{})
                })
                .then((ignore)=>{
                    if (bDone) return
                    var tasks: Promise<any>[] = [];
                    tasks.push(saveFunction(esWB_ReportTile_Dimension, self.drWB_Report.WB_ReportTileDimensionRows));
                       return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (bDone) return
                    if (bBatch) {
                        self.dbContext.addBatchCompleteListener(()=> {
                            self._bIsSaved = true;
                        })
                    } else {
                        self._bIsSaved = true;
                    }
                    self.SaveProgressProvider.finish();
                    resolve(self);
                })
                .catch((err) => {
                    self.SaveProgressProvider.exception(err);
                    resolve(self)
                })

        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbReport = <IwbReportTile>self.drWB_Report;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbReport.REPORT_NAME + "(" + wbReport.REPORT_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the Report

            // 2. If Valid, mark all the records for deletion.
            self.drWB_Report.markDeleted()
            _.forEach(self.drWB_Report.WB_ReportTileDimensionRows, (a) => a.markDeleted());

            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>
    //<editor-fold desc = "Term operations">
    addReportDimension(aWbDimId: number, options: any): Promise<WB_ReportTileDimensionRow> {
        let self = this;

        return new Promise<WB_ReportTileDimensionRow>((resolve, error) => {

            let aDimensionRow: WB_DimensionRow  = undefined
            // Is the dimension in the term table?
            self.dbContext.find(esWB_Dimension, aWbDimId )
                .then((aDimRec: WB_DimensionRow) => {
                    if(!aDimRec){
                        // Bad Dimension ID
                        resolve(undefined)
                        return
                    }
                    aDimensionRow = aDimRec;
                    // create new records
                    return self.dbContext.createRecordWithKey(esWB_ReportTile_Dimension)
                })
                .then((aNewRow: WB_ReportTileDimensionRow) => {
                    if(!aNewRow){
                        resolve(undefined)
                        return
                    }
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_REPORTTILE_ID = self.drWB_Report.cif.WB_REPORTTILE_ID;
                    aNewRow .cif.WB_DIMENSION_ID = aDimensionRow.cif.WB_DIMENSION_ID;
                    aNewRow.cif.SORT_ORDER= self.drWB_Report.WB_ReportTileDimensionRows.length
                    aNewRow.WB_DimensionRow= aDimensionRow
                    self.dbContext.add(esWB_ReportTile_Dimension, aNewRow)
                    resolve(aNewRow)
                })
                .catch((err) => {
                    error(err)
                })
        })

    }

    removeReportDimension(aWbDimId: number, options: any): Promise<void> {
        let self = this

        return new Promise<void> ((resolve, error) => {

            _.forEach(self.drWB_Report.WB_ReportTileDimensionRows, (aDimRow: WB_ReportTileDimensionRow) => {
                if (aDimRow.isActive && aDimRow.cif.WB_RPTTLDR_ID == aWbDimId) {
                    aDimRow.markDeleted()
                    aDimRow.off()  // Turn off Event Generation
                }
            })

            resolve()
        })

    }

    clearReportDimension(): Promise<void> {
        let self = this

        return new Promise<void> ((resolve, reject) => {
            _.forEach(self.drWB_Report.WB_ReportTileDimensionRows, (aDimRow: WB_ReportTileDimensionRow) => {
                console.log(aDimRow)
                if (aDimRow.isActive) {
                    aDimRow.markDeleted()
                    aDimRow.off()
                }
            })
            resolve()
        })
    }

};
PAEnvironment.registerBusinessObjectClass( ReportTileBO, "ReportTileBO" ,"Report Tile")